import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD2ZJl_O-Ar3PPXBfWo-ZSlZ6w2KO-Ini8",
  authDomain: "donggukfc-ef052.firebaseapp.com",
  projectId: "donggukfc-ef052",
  storageBucket: "donggukfc-ef052.firebasestorage.app",
  messagingSenderId: "467197673576",
  appId: "1:467197673576:web:91e0e247da0dff349d7bdd"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
